<!--
 * @Author: 汪俊洪
 * @Date: 2025-02-10 16:12:40
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-02-14 15:12:55
 * @Description:
-->
<template>
  <div>
    <CategorizeAndBrand :list="list" />
  </div>
</template>

<script>
import CategorizeAndBrand from './components/categorizeAndBrand.vue'
export default {
  components: {
    CategorizeAndBrand
  },
  data () {
    return {
      list: []
    }
  },
  created () {
    if (window.screen.width < 750) {
      this.jumpH5()
      return
    }
    this.getList()
  },
  methods: {
    getList () {
      this.$http
        .get(
          '/front/cross/commodity-user/boutique/category/brands?brandPageSize=20'
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            console.log(res.data)
            this.list = res.data || []
          }
        })
    },
    jumpH5 () {
      let origin = window.location.origin
      origin = origin
        .replace('www.', 'm.')
        .replace('uat2-', 'uat2m-')
        .replace('pretest.', 'pretestm.')
        .replace('predev.', 'predevm.')
        .replace('uat.', 'uatm.')
      window.location.href = origin + '/#/pages/premium/index'
    }
  }
}
</script>

<style lang="scss" scoped></style>
